import React, { useState, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import styles from './LogoUpload.module.css';

export default function LogoUpload({ organisatieId, huidigeLogo, onLogoGewijzigd }) {
  const [laden, setLaden]       = useState(false);
  const [preview, setPreview]   = useState(null);
  // Sync met huidigeLogo prop als die verandert
  React.useEffect(() => { if (huidigeLogo && !preview) setPreview(huidigeLogo); }, [huidigeLogo]);
  const inputRef                = useRef(null);

  async function handleVerwijderen() {
    if (!window.confirm('Logo verwijderen? De Alyden standaard wordt dan gebruikt.')) return;
    try {
      await axios.delete(`/api/ai-instructies/organisaties/${organisatieId}/logo`);
      setPreview(null);
      toast.success('Logo verwijderd.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Verwijderen mislukt.');
    }
  }

  async function handleBestand(e) {
    const bestand = e.target.files[0];
    if (!bestand) return;

    // Preview tonen
    const reader = new FileReader();
    reader.onload = ev => setPreview(ev.target.result);
    reader.readAsDataURL(bestand);

    // Uploaden
    setLaden(true);
    try {
      const formData = new FormData();
      formData.append('logo', bestand);

      const res = await axios.post(
        `/api/ai-instructies/organisaties/${organisatieId}/logo`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      toast.success('Logo geüpload.');
      const nieuweUrl = res.data.logo_url + '?t=' + Date.now();
      setPreview(nieuweUrl);
      // Roep callback aan zonder de preview te resetten
      if (onLogoGewijzigd) onLogoGewijzigd(res.data.logo_url);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Uploaden mislukt.');
      setPreview(null);
    } finally {
      setLaden(false);
    }
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.preview}>
        {preview ? (
          <img src={preview} alt="Organisatie logo" className={styles.logo} />
        ) : (
          <div className={styles.leeg}>Geen logo</div>
        )}
      </div>
      <div className={styles.acties}>
        <button className={styles.knop} onClick={() => inputRef.current?.click()} disabled={laden}>
          {laden ? 'Uploaden...' : '📁 Logo uploaden'}
        </button>
        {preview && (
          <button className={styles.knopVerwijder} onClick={handleVerwijderen}>
            ✕ Verwijderen
          </button>
        )}
        <span className={styles.uitleg}>PNG, JPG of SVG — max 2MB</span>
      </div>
      <input ref={inputRef} type="file" accept=".png,.jpg,.jpeg,.svg"
        style={{ display: 'none' }} onChange={handleBestand} />
    </div>
  );
}
